import { useState, useRef, useEffect } from 'react';
import { BiTargetLock } from 'react-icons/bi';
import mapboxgl from 'mapbox-gl';
import axios from 'axios';
import './MapBox.css';

const { REACT_APP_MAPBOX_KEY } = process.env;
mapboxgl.accessToken = `${REACT_APP_MAPBOX_KEY}`;

const Map = ({ closeMapHandler, selectPointHandler }) => {
    const mapContainer = useRef();
    const [lat, setLat] = useState(40.41);
    const [long, setLong] = useState(-3.70);
    const [zoom, setZoom] = useState(9);
    const [mapReload, setMapReload] = useState(false);

    useEffect(() => {
        const map = new mapboxgl.Map({
            container: mapContainer.current,
            style: 'mapbox://styles/mapbox/streets-v11',
            center: [long, lat],
            zoom: zoom
        });

        // Add navigation control (the +/- zoom buttons)
        map.addControl(new mapboxgl.NavigationControl(), 'top-right');

        map.on('move', () => {
            setLong(Number(map.getCenter().lng));
            setLat(Number(map.getCenter().lat));
            setZoom(Number(map.getZoom().toFixed(2)));
        });

        return () => map.remove();

    }, [mapReload]); // eslint-disable-line react-hooks/exhaustive-deps
    
    useEffect(() => {
         if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(geolocationSuccess, geolocationError);
        } else {
            console.log('Geolocalization not available')
        }
    },[])

    // Mapbox deja en localstorage un item con mi nombre de usuario, y no me hace gracia
    // Cada vez que se cierre el mapa borro los items que haya dejado Mapbox en el localstorage
    useEffect(() => {
        return () => cleanLocalStorage();
    }, []);

    const cleanLocalStorage = () => {
        const array = []; // Array to hold the keys
        // Iterate over localStorage and insert the keys that meet the condition into arr
        for (let i = 0; i < localStorage.length; i++){
            if (localStorage.key(i).substring(0,6) === 'mapbox') {
                array.push(localStorage.key(i));
            }
        }

        // Iterate over arr and remove the items by key
        for (let i = 0; i < array.length; i++) {
            localStorage.removeItem(array[i]);
        }
    }

    const geolocationSuccess = (position) => {
        console.log('success')
        const geoLat  = position.coords.latitude;
        const geoLong = position.coords.longitude;
        setLat(geoLat);
        setLong(geoLong);
        setZoom(15);
        setMapReload(true);
    }

    const geolocationError = (error) => {
        console.log(error.message)
    }

    // La posición del nombre de la ciudad en el array cambia
    // dependiendo de si es una ciudad o un pueblo. En las
    // ciudades el array tiene 6 items y en los pueblos 5.
    const getLocality = (data) => {
        if (data.length > 5) {
            return data[3].text 
        } else {
            return data[2].text
        }
    } 

    const getPointData = () => {
        axios.get(`https://api.mapbox.com/geocoding/v5/mapbox.places/${long},${lat}.json?access_token=${REACT_APP_MAPBOX_KEY}&language=es`)
            .then(function (response) {
                const road = response.data.features[0].place_name.split(",");
                const locality = getLocality(response.data.features);
                const pointData = { "province" : road[0],
                                    "name" : locality,
                                    "lat" : response.data.query[1],
                                    "long" : response.data.query[0],
                                    "map" : true };
                selectPointHandler(pointData);
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    return (
        <>
            <div className="map-container" ref={mapContainer} />
            <div className="sidebar">
                Lat: {lat.toFixed(4)} | Long: {long.toFixed(4)} | Zoom: {zoom}
            </div>
            <div className="map__center-point"><BiTargetLock /></div>
            <div className="map__buttons">
                <button className="map__button map__button--cancel" onClick={closeMapHandler}>Cancelar</button>
                <button className="map__button map__button--ok" onClick={getPointData}>Aceptar</button>
            </div>
        </>
    );


};

export default Map;